module.exports = __webpack_public_path__ + "assets/e02253cf-f0ca-49e8-bc36-38ef6e2b9812.ca2fbf87.svg";